import { Link } from "react-router-dom";
import { Rating } from "./Rating";

export const ProductCard = ({ product }) => {
  const hasPrice = typeof product.price === "number" && product.price > 0;
  const discount = hasPrice && product.original_price > product.price
    ? Math.round(((product.original_price - product.price) / product.original_price) * 100)
    : 0;
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group bg-white border border-slate-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden flex flex-col"
    >
      <div className="relative aspect-square overflow-hidden bg-slate-50">
        <img
          src={product.images[0]}
          alt={`${product.title} — ${product.brand}`}
          loading="lazy"
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {discount > 0 && (
          <span className="absolute left-2 top-2 rounded-full bg-orange-600 px-2 py-0.5 text-xs font-bold text-white">
            -{discount}%
          </span>
        )}
        <span className="absolute right-2 top-2 rounded-full bg-white/90 px-2 py-0.5 text-[10px] font-semibold text-slate-600 backdrop-blur">
          {product.merchant}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="text-sm sm:text-base font-semibold text-slate-900 line-clamp-2">{product.title}</h3>
        {product.rating > 0 && <Rating value={product.rating} count={product.reviews_count} />}
        <div className="mt-auto flex items-baseline gap-2 pt-1">
          {hasPrice ? (
            <>
              <span className="text-lg font-black text-gold-600">${product.price.toFixed(2)}</span>
              {discount > 0 && (
                <span className="text-xs text-slate-400 line-through">${product.original_price.toFixed(2)}</span>
              )}
            </>
          ) : (
            <span className="text-sm font-extrabold text-navy-800">See today's deal →</span>
          )}
        </div>
        <span
          data-testid={`view-deal-${product.slug}`}
          className="mt-2 inline-flex items-center justify-center rounded-lg bg-gold-600 px-3 py-2 text-xs font-bold text-white transition-colors group-hover:bg-gold-700"
        >
          View Deal
        </span>
      </div>
    </Link>
  );
};
